/**
 * The single frontend definition of "the same value" for portfolio unique attributes (CS-1).
 * Must agree character for character with the backend `UniqueKeyNormalizer.normalizeUniqueKey`
 * — both are asserted against the shared fixture `src/__fixtures__/normalization-cases.json`.
 *
 * Comparison only: never write the result anywhere, never trim the user's input with it (DEC-1).
 */
export function normalizeUniqueKey(raw) {
  if (raw === null || raw === undefined) return null;
  return String(raw)
    .normalize("NFC")
    .replace(/^[\s ]+|[\s ]+$/g, "")
    .replace(/[\s ]+/g, " ")
    .toLocaleUpperCase("en-US");
}

/** True when both values normalise to the same key (two nulls are not "the same value"). */
export function sameUniqueKey(a, b) {
  const ka = normalizeUniqueKey(a);
  return ka !== null && ka === normalizeUniqueKey(b);
}

/** Mirrors `WorkPackage.getCode()`: null/empty code falls back to the name (whitespace does not). */
export function workPackageCodeKey(code, name) {
  return normalizeUniqueKey(code === null || code === undefined || code === "" ? name : code);
}

/** Mirrors `WorkPackage.getName()`: the bucket axis. */
export function workPackageNameKey(code, name) {
  return normalizeUniqueKey(name === null || name === undefined || name === "" ? code : name);
}

/** Renders every space-like character as ␣ so a whitespace-only difference is visible (CS-6). */
export function makeWhitespaceVisible(value) {
  return String(value ?? "").replace(/[\s ]/g, "␣");
}
